import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ListChecks, ArrowRight, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { useTenant } from "@/context/TenantContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const PRIORITY_STYLE = { 1: "bg-red-100 text-red-800", 2: "bg-amber-100 text-amber-800", 3: "bg-orange-100 text-orange-800" };

// "Prossimi passi": azioni per azienda in ordine di priorità, calcolate dal backend su dati reali.
export function NextStepsPanel() {
  const { changeCompany } = useTenant();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/consultant/next-steps").then((r) => setData(r.data)).catch(() => setData(null)); }, []);
  if (!data) return null;
  return (
    <Card className="border-green-200" data-testid="next-steps-panel">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <ListChecks className="w-4 h-4 text-green-700" aria-hidden="true" /> Prossimi passi
          <span className="text-xs font-normal text-slate-500" data-testid="next-steps-total">{data.total_steps} azioni</span>
        </CardTitle>
        <p className="text-xs text-slate-600">Cosa fare, in ordine di importanza, per ogni azienda che segui.</p>
      </CardHeader>
      <CardContent className="space-y-3">
        {data.companies.map((c) => (
          <div key={c.company_id} className="rounded-md border border-slate-200 p-3" data-testid={`next-steps-${c.company_id}`}>
            <p className="font-semibold text-sm text-slate-900">{c.denominazione}</p>
            {c.done ? (
              <p className="text-xs text-green-800 flex items-center gap-1 mt-1"><CheckCircle2 className="w-3.5 h-3.5" aria-hidden="true" /> Tutto in ordine: nessuna azione da fare.</p>
            ) : (
              <ol className="mt-1 space-y-1">
                {c.steps.map((s, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm">
                    <span className={`rounded px-1.5 py-0.5 text-[10px] font-bold ${PRIORITY_STYLE[s.priority] || "bg-slate-100 text-slate-700"}`}>P{s.priority}</span>
                    <Link to={s.link} onClick={() => changeCompany?.(c.company_id)} className="flex-1 hover:underline text-slate-800" data-testid={`next-step-link-${c.company_id}-${i}`}>
                      {s.label}
                    </Link>
                    <ArrowRight className="w-3.5 h-3.5 text-slate-400" aria-hidden="true" />
                  </li>
                ))}
              </ol>
            )}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
